import React, {
    forwardRef,
    useEffect,
    useImperativeHandle,
    useState,
} from "react";
import { GridRowModes } from "@mui/x-data-grid";
import { AGridColDef } from "views/pages/manage/common/data-grid/ADataGridColDef";
import ADataGrid from "views/pages/manage/common/data-grid/EnhanceDataGrid";
import { editCellContainerStyle } from "views/pages/manage/edpOps/stockManagement/mastersAndMapping/onBoardingMaterialIdSetup/constant";
import { saveOrDeleteMsg } from "views/pages/manage/edpOps/stockManagement/mastersAndMapping/sapProfitCostCentreMapping/constant";
import { gridStyles } from "views/pages/manage/edpOps/issuanceIDcard/printIdCardAndMapRfid/constant";
import { isObjEmpty } from "views/pages/manage/common/utils/methods/commonMethods/utilityMethod";
import { generateRandomId } from "views/pages/manage/common/utils/methods/commonMethods/utilityMethod";
import AAutoComplete from "views/pages/manage/common/form-fields-mui/AAutoComplete";
import moment from "moment";
import { Tooltip } from "@mui/material";
import { failureToast } from "views/pages/manage/common/utils/methods/toasterFunctions/function";
import AInput from "views/pages/manage/common/formFeilds/customInput/AInput";
import CustomChip from "views/pages/manage/common/customChip/CustomChip";
import { regex } from "views/pages/manage/common/constant/regex/index";
import { ActionsCellComponent } from 'views/pages/manage/masters/studentFinancials/paymentGatewaysConfiguration/common';
import { selectStyles, inputStyles, newRow, convertMinutesToHHMM, HHMMToMinutes, hmToMinutes, minutesToHM } from "../constants"
import { ReactComponent as CancelIcon } from 'assets/img/svg/RedCancel.svg';
import { formattedPrice } from "views/pages/manage/unAssigned/collectPayment/utils";
import { numberDecimalLimitRegex } from "views/pages/manage/unAssigned/collectPayment/selectPaymentMode/components/constant";

const ListComponent = forwardRef(
    (
        {
            currentPage = 0,
            currPageSize,
            rowCount,
            nextButtonHandler,
            rows,
            createUpdateHandler,
            isUpdatePermission,
            isLoading = { isLoading },
            srNo

        },
        ref
    ) => {
        const [rowModesModel, setRowModesModel] = useState({});

        const [rowData, setRowData] = useState(rows);
        const [rowForm, setRowForm] = useState({});
        const [time, setTime] = useState({
            hours: "",
            minutes: ""
        });

        useEffect(() => setRowData(rows), [rows]);

        const rowFormHandler = (value, key) =>
            setRowForm((prev) => ({ ...prev, [key]: value }));

        const startEditing = (id, form) => {
            setRowModesModel((oldModel) => ({ [id]: { mode: GridRowModes.Edit } }));
            setRowForm(form);

            if (form?.minutes) {
                const { hours, minutes } = minutesToHM(form.minutes);
                setTime({ hours, minutes });
            } else {
                setTime({ hours: "", minutes: "" });
            }
        };


        const stopEditing = () => {
            const currForm = { ...rowForm };
            setRowModesModel((oldModel) => ({
                [currForm?.id]: { mode: GridRowModes.View, ignoreModifications: true },
            }));
            setRowForm({});
        };

        const handleEditClick = (params) => {
            if (!isObjEmpty(rowForm)) {
                failureToast(saveOrDeleteMsg);
            } else {
                startEditing(params?.id, params?.row);
            }
        };

        const handleCancelClick = async (params) => {
            setTime({
                hours: "",
                minutes: ""
            });
            if (params?.row?.isNew) {
                setRowData(rows);
                setRowForm({});
            } else {
                stopEditing(params?.id);
            }
        };

        const handleSaveClick = async () => {

            const hours = Number(time?.hours || 0);
            const minutes = Number(time?.minutes || 0);

            const totalMinutes = hmToMinutes(hours, minutes);

            const payload = {
                ...rowForm,
                minutes: totalMinutes
            };

            createUpdateHandler(payload);
        };

        const addNewRow = async () => {
            if (!isObjEmpty(rowForm)) {
                failureToast(saveOrDeleteMsg);
            } else {
                let randomId = generateRandomId();
                let emptyRow = {
                    ...newRow,
                    isNew: true,
                    id: randomId
                };
                startEditing(randomId, emptyRow);
                setRowData((prev) => [emptyRow, ...prev]);
            }
        };

        useImperativeHandle(ref, () => ({
            addNewRow: addNewRow,
            startEditing: startEditing,
            stopEditing: stopEditing,
        }));


        const columns = [
            new AGridColDef("srNo", "Sr No.", false)
                .setMinWidth(80)
                .editable(false)
                .setFlex(1)
                .renderCellComponent((params) => (
                    params?.value ? <div><Tooltip title={params?.value}>
                        <div className={`ellipsis-text-container`}>{params?.value}</div>
                    </Tooltip></div> : <div>-</div>
                )),
            new AGridColDef("minutes", "No. of hours", false)
                .setMinWidth(80)
                .setFlex(1)
                .editable(true)

                .renderCellComponent((params) =>
                    params?.row?.minutes ? (
                        <Tooltip title={convertMinutesToHHMM(params.row.minutes)}>
                            <div className="ellipsis-text-container">
                                {convertMinutesToHHMM(params.row.minutes)}
                            </div>
                        </Tooltip>
                    ) : (
                        "-"
                    )
                )

                .renderEditCellComponent((params) => {
                    const totalMinutes = rowForm?.minutes ?? params?.row?.minutes ?? 0;
                    const { hours, minutes } = minutesToHM(totalMinutes);

                    if (time?.hours === "" && time?.minutes === "" && totalMinutes) {
                        setTime({
                            hours,
                            minutes
                        });
                    }
                    return (
                        <div style={editCellContainerStyle}>
                            <div style={{ display: "flex", gap: "8px" }}>
                                <AInput
                                    value={time?.hours}
                                    placeholder="H"
                                    style={{ width: "45px", textAlign: "center" }}
                                    regex={regex?.numeric}
                                    maxLength={2}
                                    handler={(val) => {

                                        if (val === "" || val === null) {
                                            setTime((prev) => ({ ...prev, hours: "" }));
                                            return;
                                        }

                                        const hoursVal = Number(val);

                                        if (hoursVal >= 0 && hoursVal <= 12) {
                                            setTime((prev) => ({
                                                ...prev,
                                                hours: hoursVal
                                            }));
                                        }
                                    }}
                                />

                                <AInput
                                    value={time?.minutes}
                                    placeholder="M"
                                    style={{ width: "45px", textAlign: "center" }}
                                    regex={regex?.numeric}
                                    maxLength={2}
                                    handler={(val) => {

                                        if (val === "" || val === null) {
                                            setTime((prev) => ({ ...prev, minutes: "" }));
                                            return;
                                        }

                                        const minVal = Number(val);

                                        if (minVal >= 0 && minVal <= 59) {
                                            setTime((prev) => ({
                                                ...prev,
                                                minutes: minVal
                                            }));
                                        }
                                    }}
                                />
                            </div>
                        </div>
                    );
                }),
            new AGridColDef("amount", "Amount", false)
                .setMinWidth(80)
                .editable(true)
                .setFlex(1)
                .renderCellComponent((params) => (
                    params?.value !== null && params?.value !== undefined ?
                        <div><Tooltip title={formattedPrice(params?.value)}>
                            <div className={`ellipsis-text-container`}>{formattedPrice(params?.value)}</div>
                        </Tooltip></div> : <div>-</div>
                ))
                .renderEditCellComponent((params) => (
                    <div style={editCellContainerStyle}>
                        <AInput
                            value={rowForm?.amount}
                            handler={(val) => {
                                if (val === "" || val === null) {
                                    rowFormHandler("", "amount");
                                } else if (val >= 0) {
                                    rowFormHandler(val, "amount");
                                }
                            }}
                            placeholder={""}
                            disabled={false}
                            style={inputStyles}
                            regex={numberDecimalLimitRegex(10, 2)}
                        />
                    </div>)),
            new AGridColDef("actions", "Actions", false)
                .setMinWidth(130)
                .columnAlign("right")
                .setFlex(1)
                .renderCellComponent((params) => (
                    <div className='d-flex align-items-center' style={{ gap: '15px' }}>
                        <ActionsCellComponent
                            mode={params.api.getRowMode(params?.id)}
                            params={params}
                            handleEditClick={handleEditClick}
                            handleCancelClick={handleCancelClick}
                            handleSaveClick={handleSaveClick}
                            rowForm={rowForm}
                            icon={true}
                            cancelIcon={<CancelIcon
                                className="mx-2 cursor"
                                onClick={() => handleCancelClick(params)}
                            />
                            }
                            editPermission={isUpdatePermission}
                            customEditIcon
                            isSaveDisabled={
                                rowForm?.amount === "" ||
                                time?.hours === "" ||
                                time?.minutes === ""
                            }
                        />
                    </div>

                )
                ),
        ];
        return (
            <div className="mt-3">
                <ADataGrid
                    removeWrapperContainer
                    rowModesModel={rowModesModel}
                    rows={rowData || []}
                    columns={columns}
                    rowId={(row) => row?.id}
                    rowHeight={50}
                    rowCount={rowCount}
                    loading={false}
                    currentPage={currentPage}
                    nextButtonHandler={nextButtonHandler}
                    sx={{
                        ...gridStyles,
                    }}
                    autoHeight
                    hidePagination
                // paginationModel={{ page: currentPage, pageSize: currPageSize }}
                />
            </div>
        );
    }
);
export default ListComponent;
